var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlaskIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_534_",
    style: {
      fill: "#7FD0FD"
    },
    d: "M512,255.904c0,70.692-28.654,134.692-74.981,181.019S326.692,511.904,256,511.904 S121.308,483.25,74.981,436.924S0,326.597,0,255.904S28.654,121.212,74.981,74.885S185.308-0.096,256-0.096 s134.692,28.654,181.019,74.981S512,185.212,512,255.904z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3115_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_817_",
    style: {
      fill: "#FDD347"
    },
    d: "M146.938,41.195h-2.391h-2.391c-28.871,0-55.009,11.702-73.93,30.623 s-30.623,45.058-30.623,73.93v76.672v76.672c0,13.703,5.554,26.109,14.534,35.089s21.386,14.534,35.089,14.534h57.319h57.319 c13.703,0,26.109-5.554,35.089-14.534s14.534-21.386,14.534-35.089v-76.672v-76.672c0-28.871-11.702-55.009-30.623-73.93 S175.809,41.195,146.938,41.195z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3095_",
    style: {
      fill: "#E3B743"
    },
    d: "M145.906,348.714h-29.82h-29.82c-13.705,0-26.11-5.555-35.089-14.535 c-8.979-8.98-14.531-21.385-14.531-35.085v-76.675v-76.675c0-28.87,11.703-55.007,30.623-73.927s45.058-30.623,73.928-30.623h2.39 h2.39c4.745,0,9.417,0.315,13.996,0.929s9.064,1.526,13.434,2.721c-22.22,6.02-41.5,19.182-55.225,36.871 s-21.895,39.904-21.895,64.029v76.675v76.675c0,13.7,5.552,26.105,14.531,35.085C119.796,343.159,132.201,348.714,145.906,348.714 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_908_",
    style: {
      fill: "#D5D3D2"
    },
    d: "M251.49,384.634l-0.39,63.605l-0.39,63.605 c-35.35-0.715-68.94-8.595-99.379-22.248c-30.439-13.652-57.726-33.077-80.471-56.882v10.925v10.925 c-1.42-0.11-2.685-0.757-3.595-1.737c-0.91-0.98-1.465-2.292-1.465-3.732v-10.92v-10.92c-5.58-6.19-10.86-12.652-15.819-19.366 s-9.596-13.679-13.891-20.874l0.005-1.19l0.005-1.19c0-10.995,1.668-21.473,4.686-31.017c3.019-9.545,7.389-18.158,12.794-25.423 c5.52-7.425,12.122-13.44,19.47-17.599s15.44-6.461,23.94-6.461h46.805H190.6c1.045,0,2.085,0.035,3.119,0.105 c1.034,0.07,2.061,0.175,3.081,0.315c2.345,0.31,4.652,0.797,6.912,1.452c2.26,0.655,4.473,1.478,6.628,2.458 c4.52,2.045,8.797,4.772,12.765,8.09s7.625,7.225,10.905,11.63c5.405,7.265,9.775,15.88,12.794,25.428 C249.823,363.159,251.49,373.639,251.49,384.634z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_897_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M251.49,384.634l-0.39,63.605l-0.39,63.605 c-35.35-0.715-68.94-8.595-99.379-22.248c-30.439-13.652-57.726-33.077-80.471-56.882v-24.04v-24.04 c0-7.75,0.83-15.245,2.377-22.337s3.812-13.783,6.682-19.923c0.695-1.485,1.425-2.94,2.19-4.36c0.765-1.42,1.565-2.805,2.4-4.15 c1.795-2.92,3.742-5.672,5.827-8.234c2.085-2.561,4.308-4.931,6.652-7.086c2.74-2.53,5.647-4.768,8.695-6.68 c3.048-1.912,6.235-3.5,9.535-4.73c0.08-0.03,0.16-0.06,0.241-0.089s0.164-0.056,0.249-0.081c1.94-0.7,3.92-1.278,5.935-1.724 c2.015-0.446,4.065-0.761,6.145-0.936c0.655-0.055,1.315-0.098,1.977-0.126s1.327-0.044,1.993-0.044h29.42h29.42 c1.045,0,2.085,0.035,3.119,0.105c1.034,0.07,2.061,0.175,3.081,0.315c2.345,0.31,4.652,0.797,6.912,1.452 c2.26,0.655,4.473,1.478,6.628,2.458c4.52,2.045,8.797,4.772,12.765,8.09s7.625,7.225,10.905,11.63 c5.405,7.265,9.775,15.88,12.794,25.428C249.823,363.159,251.49,373.639,251.49,384.634z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_824_",
    style: {
      fill: "#E09D6E"
    },
    d: "M174.001,277.142v20.923v20.923c0,3.358-1.361,6.398-3.562,8.599 c-2.201,2.201-5.241,3.562-8.599,3.562h-17.229h-17.229c-3.358,0-6.398-1.361-8.599-3.562s-3.562-5.241-3.562-8.599v-20.923 v-20.923h29.389H174.001z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_823_",
    style: {
      fill: "#FBB47A"
    },
    d: "M174.001,277.142v21.659v21.659c0,2.951-1.196,5.623-3.13,7.557 c-1.934,1.934-4.606,3.13-7.557,3.13h-17.764h-17.764v-27.003v-27.003h23.108H174.001z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_821_",
    style: {
      fill: "#FBB47A"
    },
    d: "M24.5,183.562c0,6.031,2.445,11.492,6.397,15.444s9.413,6.397,15.444,6.397 s11.492-2.445,15.444-6.397c3.953-3.952,6.397-9.413,6.397-15.444s-2.445-11.492-6.397-15.444 c-3.952-3.952-9.413-6.397-15.444-6.397s-11.492,2.445-15.444,6.397S24.5,177.53,24.5,183.562z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_820_",
    style: {
      fill: "#D29169"
    },
    d: "M37.605,183.562c0,2.413,0.978,4.597,2.559,6.178 c1.581,1.581,3.765,2.559,6.178,2.559s4.597-0.978,6.178-2.559c1.581-1.581,2.559-3.765,2.559-6.178s-0.978-4.597-2.559-6.178 c-1.581-1.581-3.765-2.559-6.178-2.559s-4.597,0.978-6.178,2.559C38.583,178.965,37.605,181.149,37.605,183.562z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_34_",
    style: {
      fill: "#FBB47A"
    },
    d: "M219.406,183.562c0,6.031,2.445,11.492,6.397,15.444s9.413,6.397,15.444,6.397 s11.492-2.445,15.444-6.397c3.953-3.952,6.397-9.413,6.397-15.444s-2.445-11.492-6.397-15.444 c-3.952-3.952-9.413-6.397-15.444-6.397s-11.492,2.445-15.444,6.397S219.406,177.53,219.406,183.562z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_818_",
    style: {
      fill: "#E09D6E"
    },
    d: "M232.51,183.562c0,2.413,0.978,4.597,2.559,6.178 c1.581,1.581,3.765,2.559,6.178,2.559s4.597-0.978,6.178-2.559c1.581-1.581,2.559-3.765,2.559-6.178s-0.978-4.597-2.559-6.178 c-1.581-1.581-3.765-2.559-6.178-2.559s-4.597,0.978-6.178,2.559C233.488,178.965,232.51,181.149,232.51,183.562z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_814_",
    style: {
      fill: "#E09D6E"
    },
    d: "M68.18,198.115v-25.59v-25.59c0-0.86,0.013-1.718,0.038-2.573 s0.063-1.707,0.113-2.557h-3.025H62.28c-2.235,0-4.41-0.253-6.505-0.73c-2.095-0.478-4.11-1.18-6.025-2.08 c-0.495-0.235-0.982-0.48-1.462-0.739c-0.48-0.259-0.952-0.531-1.418-0.821c-0.18,1.56-0.312,3.132-0.4,4.716 c-0.087,1.584-0.13,3.179-0.13,4.784v25.59v25.59c0,22.59,9.155,43.037,23.955,57.837s35.245,23.952,57.825,23.952h10.925h10.925 c-22.585,0-43.032-9.155-57.834-23.956S68.18,220.7,68.18,198.115z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_822_",
    style: {
      fill: "#FBB47A"
    },
    d: "M240.72,137.445c-1.985,1.215-4.112,2.2-6.351,2.924 c-2.239,0.724-4.589,1.186-7.019,1.356c-0.335,0.025-0.673,0.045-1.012,0.059c-0.34,0.014-0.682,0.021-1.027,0.021h-13.33h-13.33 c-2.825,0-5.555-0.408-8.146-1.164c-2.591-0.756-5.044-1.861-7.314-3.256c-4.495-2.765-8.26-6.69-10.906-11.384 c-2.646-4.694-4.174-10.156-4.194-15.996c-0.04,8.785-3.473,16.735-9,22.489c-5.528,5.754-13.15,9.311-21.57,9.311h-34.595H68.33 c-0.05,0.85-0.088,1.702-0.113,2.557s-0.038,1.712-0.038,2.573v25.59v25.59c0,22.585,9.155,43.032,23.956,57.834 s35.249,23.956,57.834,23.956h4.75h4.75c22.58,0,43.023-9.152,57.82-23.952s23.95-35.247,23.95-57.837v-25.59v-25.59 c0-1.605-0.042-3.198-0.129-4.779C241.025,140.575,240.895,139.005,240.72,137.445z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_813_",
    style: {
      fill: "#E29F6E"
    },
    d: "M152.881,216.021h-8.267h-8.267c-2.363,0-4.503-0.958-6.052-2.507 s-2.507-3.688-2.507-6.052v0v0c0-2.363,0.958-4.503,2.507-6.052s3.688-2.507,6.052-2.507h8.267h8.267 c2.363,0,4.503,0.958,6.052,2.507s2.507,3.688,2.507,6.052v0v0c0,2.363-0.958,4.503-2.507,6.052S155.244,216.021,152.881,216.021z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_812_",
    style: {
      fill: "#1F3D5C"
    },
    d: "M95.47,205.403L95.47,205.403L95.47,205.403c-3.242,0-6.177-1.314-8.301-3.438 c-2.124-2.124-3.438-5.059-3.438-8.301v-7.235v-7.235c0-3.242,1.314-6.177,3.438-8.301c2.124-2.124,5.059-3.438,8.301-3.438h0h0 c3.242,0,6.177,1.314,8.301,3.438c2.124,2.124,3.438,5.059,3.438,8.301v7.235v7.235c0,3.242-1.314,6.177-3.438,8.301 C101.647,204.089,98.712,205.403,95.47,205.403z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_811_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M94.105,178.647c0,1.508,0.611,2.873,1.599,3.861 c0.988,0.988,2.353,1.599,3.861,1.599s2.873-0.611,3.861-1.599s1.599-2.353,1.599-3.861c0-1.508-0.611-2.873-1.599-3.861 c-0.988-0.988-2.353-1.599-3.861-1.599s-2.873,0.611-3.861,1.599C94.716,175.774,94.105,177.139,94.105,178.647z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_810_",
    style: {
      fill: "none",
      stroke: "#1F3D5C",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M123.591,236.936c0,5.805,2.353,11.061,6.157,14.865c3.804,3.804,9.06,6.157,14.865,6.157c5.805,0,11.061-2.353,14.865-6.157 c3.804-3.804,6.157-9.06,6.157-14.865"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_809_",
    style: {
      fill: "none",
      stroke: "#1F3D5C",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M209.616,177.982c0,0,1.84-0.33,3.962-1.473c2.121-1.143,4.524-3.1,5.649-6.354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_808_",
    style: {
      fill: "none",
      stroke: "#1F3D5C",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M85.963,177.982c0,0-1.84-0.33-3.962-1.473c-2.121-1.143-4.524-3.1-5.649-6.354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_807_",
    style: {
      fill: "#1F3D5C"
    },
    d: "M198.943,205.403L198.943,205.403L198.943,205.403 c-3.242,0-6.177-1.314-8.301-3.438s-3.438-5.059-3.438-8.301v-7.235v-7.235c0-3.242,1.314-6.177,3.438-8.301 s5.059-3.438,8.301-3.438h0h0c3.242,0,6.177,1.314,8.301,3.438c2.124,2.124,3.438,5.059,3.438,8.301v7.235v7.235 c0,3.242-1.314,6.177-3.438,8.301C205.12,204.089,202.185,205.403,198.943,205.403z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_806_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M197.578,178.647c0,1.508,0.611,2.873,1.599,3.861 c0.988,0.988,2.353,1.599,3.861,1.599c1.508,0,2.873-0.611,3.861-1.599c0.988-0.988,1.599-2.353,1.599-3.861 c0-1.508-0.611-2.873-1.599-3.861c-0.988-0.988-2.353-1.599-3.861-1.599c-1.508,0-2.873,0.611-3.861,1.599 C198.19,175.774,197.578,177.139,197.578,178.647z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_805_",
    style: {
      fill: "#D5D3D2"
    },
    d: "M115.222,304.138l-15.181,9.163l-15.181,9.163c-2.046,1.235-3.15,3.305-3.27,5.43 s0.745,4.307,2.639,5.763l10.398,7.997l10.398,7.997l-12.273,11.994L80.48,373.64c-1.19,1.163-1.871,2.671-2.015,4.229 c-0.144,1.558,0.248,3.166,1.204,4.527l32.472,46.24l32.472,46.24l-14.695-85.369L115.222,304.138z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_804_",
    style: {
      fill: "#D5D3D2"
    },
    d: "M174.001,304.138l15.182,9.163l15.182,9.163c2.046,1.235,3.15,3.305,3.27,5.43 c0.12,2.126-0.745,4.307-2.639,5.763l-10.398,7.997l-10.398,7.997l12.273,11.994l12.273,11.994 c1.19,1.163,1.871,2.671,2.015,4.229s-0.248,3.166-1.204,4.527l-32.472,46.24l-32.472,46.24l14.694-85.369L174.001,304.138z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_803_",
    style: {
      fill: "#D5D3D2"
    },
    d: "M237.157,432.411h-18.133h-18.133c-1.129,0-2.151-0.457-2.89-1.197 c-0.74-0.74-1.197-1.762-1.197-2.89v-5.24v-5.24c0-1.129,0.458-2.151,1.197-2.89c0.74-0.74,1.762-1.197,2.89-1.197h18.133h18.133 c1.129,0,2.151,0.457,2.89,1.197c0.74,0.74,1.197,1.762,1.197,2.89v5.24v5.24c0,1.129-0.458,2.151-1.197,2.89 C239.308,431.954,238.286,432.411,237.157,432.411z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_802_",
    style: {
      fill: "none",
      stroke: "#FB4755",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: " 96.993,304.138 96.993,340.292 96.993,376.447  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_801_",
    style: {
      fill: "none",
      stroke: "#FB4755",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: " 196.804,304.138 196.804,340.292 196.804,376.447  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_861_",
    style: {
      fill: "none",
      stroke: "#FB4755",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M114.2,454.584h4.245h4.245c1.185,0,2.28-0.375,3.175-1.013c0.895-0.637,1.59-1.538,1.975-2.587 c0.11-0.295,0.195-0.603,0.253-0.919c0.057-0.316,0.087-0.641,0.087-0.971v-20.335v-20.335c0-4.305-0.872-8.408-2.45-12.139 c-1.578-3.731-3.86-7.091-6.68-9.911c-2.825-2.825-6.188-5.11-9.92-6.689c-3.732-1.579-7.835-2.451-12.14-2.451 c-3.195,0-6.277,0.48-9.18,1.372c-2.902,0.893-5.625,2.198-8.1,3.848c-1.76,1.175-3.395,2.525-4.879,4.024 s-2.816,3.146-3.971,4.916c-1.6,2.45-2.865,5.138-3.73,7.997c-0.865,2.86-1.33,5.892-1.33,9.033v9.415v9.415v10.92v10.92 c0,1.44,0.555,2.752,1.465,3.732c0.91,0.98,2.175,1.628,3.595,1.738c0.07,0.005,0.143,0.01,0.216,0.014 c0.074,0.004,0.149,0.006,0.224,0.006h3.035h3.035"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_799_",
    style: {
      fill: "#FB4755"
    },
    d: "M174.001,397.052c0,6.297,2.552,11.998,6.679,16.124 c4.127,4.127,9.827,6.679,16.124,6.679c6.297,0,11.998-2.552,16.124-6.679c4.127-4.127,6.679-9.827,6.679-16.124 c0-6.297-2.552-11.998-6.679-16.124c-4.127-4.127-9.827-6.679-16.124-6.679c-6.297,0-11.998,2.552-16.124,6.679 C176.553,385.054,174.001,390.755,174.001,397.052z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_798_",
    style: {
      fill: "#FC646F"
    },
    d: "M184.833,397.052c0,3.306,1.34,6.298,3.506,8.465s5.159,3.506,8.465,3.506 s6.298-1.34,8.465-3.506s3.506-5.159,3.506-8.465s-1.34-6.298-3.506-8.465s-5.159-3.506-8.465-3.506s-6.298,1.34-8.465,3.506 S184.833,393.746,184.833,397.052z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_796_",
    style: {
      fill: "#FAA268"
    },
    d: "M471.5,371.436H383h-88.5c-3.866,0-7.366-1.567-9.9-4.1 c-2.533-2.534-4.1-6.034-4.1-9.9v-120.5v-120.5c0-3.866,1.567-7.366,4.1-9.899c2.534-2.534,6.034-4.101,9.9-4.101H383h88.5 c3.866,0,7.366,1.567,9.9,4.101c2.533,2.534,4.1,6.034,4.1,9.899v120.5v120.5c0,3.866-1.567,7.366-4.1,9.9 C478.866,369.869,475.366,371.436,471.5,371.436z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_795_",
    style: {
      fill: "#D9D9D9"
    },
    d: "M468.5,122.312v114.625v114.625c0,1.485-0.602,2.827-1.576,3.799 s-2.319,1.571-3.804,1.571H383h-80.12c-1.485,0-2.83-0.6-3.804-1.571s-1.576-2.314-1.576-3.799V236.937V122.312 c0-1.485,0.602-2.83,1.576-3.804s2.319-1.576,3.804-1.576H383h80.12c1.485,0,2.83,0.602,3.804,1.576S468.5,120.827,468.5,122.312z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_794_",
    style: {
      fill: "#FDFAF8"
    },
    d: "M468.5,122.312v114.625v114.625c0,1.485-0.602,2.827-1.576,3.799 s-2.319,1.571-3.804,1.571H395.5h-67.62c-1.485,0-2.83-0.6-3.804-1.571s-1.576-2.314-1.576-3.799V236.937V122.312 c0-1.485,0.602-2.83,1.576-3.804s2.319-1.576,3.804-1.576h67.62h67.62c1.485,0,2.83,0.602,3.804,1.576 S468.5,120.827,468.5,122.312z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_793_",
    style: {
      fill: "#E3769C"
    },
    d: "M425.5,103.192v10v10c0,2.07-0.84,3.945-2.198,5.303 c-1.357,1.357-3.232,2.197-5.302,2.197h-35h-35c-2.07,0-3.945-0.84-5.302-2.197c-1.358-1.358-2.198-3.233-2.198-5.303v-10v-10 c0-2.07,0.84-3.945,2.198-5.303c1.357-1.357,3.232-2.197,5.302-2.197h35h35c2.07,0,3.945,0.84,5.302,2.197 C424.66,99.247,425.5,101.122,425.5,103.192z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_792_",
    style: {
      fill: "#FB80A5"
    },
    d: "M425.5,103.192v10v10c0,2.07-0.84,3.945-2.198,5.303 c-1.357,1.357-3.232,2.197-5.302,2.197h-24h-24c-2.07,0-3.945-0.84-5.302-2.197c-1.358-1.358-2.198-3.233-2.198-5.303v-10v-10 c0-2.07,0.84-3.945,2.198-5.303c1.357-1.357,3.232-2.197,5.302-2.197h24h24c2.07,0,3.945,0.84,5.302,2.197 C424.66,99.247,425.5,101.122,425.5,103.192z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_791_",
    style: {
      fill: "#E0A47F"
    },
    d: "M410.665,87.692v4v4H383h-27.665v-4v-4c0-1.84,0.745-3.508,1.951-4.715 s2.874-1.955,4.719-1.955h21h21c1.84,0,3.505,0.748,4.71,1.955S410.665,85.852,410.665,87.692z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_790_",
    style: {
      fill: "#F7B588"
    },
    d: "M410.665,87.692v4v4h-20.5h-20.5v-4v-4c0-1.84,0.747-3.508,1.955-4.715 c1.208-1.208,2.875-1.955,4.715-1.955h13.835h13.835c1.84,0,3.505,0.748,4.71,1.955S410.665,85.852,410.665,87.692z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_789_",
    style: {
      fill: "none",
      stroke: "#1F3D5C",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 325.167,202.923 340.5,202.923 355.833,202.923 355.833,187.59 355.833,172.257 340.5,172.257 325.167,172.257 325.167,187.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_788_",
    style: {
      fill: "none",
      stroke: "#1F3D5C",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 325.167,259.452 340.5,259.452 355.833,259.452 355.833,244.119 355.833,228.786 340.5,228.786 325.167,228.786 325.167,244.119  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_787_",
    style: {
      fill: "none",
      stroke: "#1F3D5C",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 325.167,311.127 340.5,311.127 355.833,311.127 355.833,295.794 355.833,280.46 340.5,280.46 325.167,280.46 325.167,295.794  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_786_",
    style: {
      fill: "none",
      stroke: "#1F3D5C",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 369.665,185.457 405.916,185.457 442.167,185.457  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_785_",
    style: {
      fill: "none",
      stroke: "#1F3D5C",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 369.665,244.119 405.916,244.119 442.167,244.119  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_784_",
    style: {
      fill: "none",
      stroke: "#1F3D5C",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 369.665,295.794 405.916,295.794 442.167,295.794  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_783_",
    style: {
      fill: "none",
      stroke: "#95D52A",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 333.5,190.747 337,193.537 340.5,196.327 353,185.403 365.5,174.48  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_782_",
    style: {
      fill: "none",
      stroke: "#95D52A",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 333.5,245.052 337,247.842 340.5,250.632 353,239.709 365.5,228.786  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlaskIcon);
export default __webpack_public_path__ + "static/media/flask-icon.ae3039d8ea7c0b489188a6a7728d4f92.svg";
export { ForwardRef as ReactComponent };